import {Routes} from '@angular/router';
import {LoginComponent} from './login/login.component';

export const SharedRoutes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
];
